<template>
  <div class="about">
    <h1>About This Test</h1>
    <p>This Vue.js SPA is designed to test the WP Engine Atlas 404 routing solution.</p>
    <p>It uses Vue Router in history mode to handle client-side routing.</p>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped>
.about {
  padding: 2rem;
}
</style>